var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex fj-cent fa-cent"},[_c('svgIcon',{staticClass:"terminal-input-icon stroke",attrs:{"name":"bot"}}),_c('input',{staticClass:"terminal-input-field",attrs:{"type":"textarea","value":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }